import { StatusBar } from 'expo-status-bar';
import React,{useEffect,useState}  from 'react';
import { StyleSheet, Text,  Image,View, SafeAreaView,ScrollView,TouchableOpacity} from 'react-native';
import ButtonGradient from '../modules/component/ButtonGradient';
import { useNavigation } from '@react-navigation/native';
import Fondo from '../modules/component/Fondo';
import Incidencias from './Incidencias';
import DropDownPicker from 'react-native-dropdown-picker'


  const Tienda = () => {
  const navigation = useNavigation();

  function irIncidencias(){
    gPantalla = "";
    gCheckbox = "";
    navigation.navigate("Incidencias");

  }

  const base64Icon = 'http://www.eurekamx.com:9092/api/imagenUPC?archivo=' + gUpc + '.jpg';
  
    return(
        <SafeAreaView style={styles.container}>
            <ScrollView style={styles.scrollView}>
    
                <Fondo/>

                <View style={{flex:1, alignItems:'center', justifyContent:'center'}}>

                    <Text style={styles.subTitle}>UPC: {gUpc}</Text>
                    <Image style={{width: 300, height: 300,  marginTop : 10}} source={{uri: base64Icon}}/>
                    <Text style={styles.subTitle2}>¿Que desea registrar?</Text>
                    <TouchableOpacity  style={styles.container2} onPress={()=>navigation.navigate('UPC')}>
                        <ButtonGradient texto="Inventarios" />
                    </TouchableOpacity>
                    <TouchableOpacity  style={styles.container2} onPress={()=>irIncidencias()}>
                        <ButtonGradient texto="Incidencias" />
                    </TouchableOpacity>
                    <StatusBar style="auto" />
                </View>  
        </ScrollView>
      </SafeAreaView>
    
    );
  }

export default Tienda

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: '#f1f1f1',
    alignItems: 'center',
    justifyContent: 'center',
  

  },container2:{
      
    alignItems: 'center',
    justifyContent : 'center',
    marginTop:20,
    width: '80%',
    marginBottom : 20
},

  titulo1:{
    fontSize: 50,
    color: "white",
    fontWeight: 'bold',
    marginTop: 50,
  },


  titulo3:{
    fontSize: 50,
    color: "white",
    fontWeight: 'bold'
  },

  subTitle:{
    fontSize: 30,
    color: 'white',
    marginTop: 10,
    textAlign : 'center',
    fontWeight: 'bold'
  },

  subTitle2:{
    fontSize: 25,
    color: 'white',
    marginTop: 10,
    textAlign : 'center',
    fontWeight: 'bold'

  },
scrollView: {
  marginHorizontal: 20,
  width: '100%',
  height: '100%'
}

  
});

